/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import {
    shape, string, object, func,
} from 'prop-types';

const styles = (theme) => ({
    templateContainer: {
        width: '100%',
        textAlign: 'center',
    },
    box: {
        width: '100%',
        display: 'inline-flex',
        flexDirection: 'column',
        justifyContent: 'center',
        cursor: 'pointer',
        paddingLeft: 10,
        textAlign: 'center',
    },
    image: {
        maxHeight: 140,
        maxWidth: 140,
        cursor: 'pointer',
    },
    templateTitle: {
        fontSize: 12,
        color: theme.palette.cgc?.bgTextOverlay1 || 'rgba(0,0,0,0.6)',
        display: 'flex',
        maxWidth: '160px',
    },
    templateWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    templateVertical: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 160,
        width: 160,
        minWidth: 160,
        background: theme.palette.cgc?.colorNeutral20 || '#f5f5f5',
        '&:hover': {
            transform: 'scale(1.025)',
            border: `1px solid ${theme.palette.colorNeutral20 || '#ccc'}`,
            boxShadow: `5px 3px ${theme.palette.colorNeutral20 || 'whitesmoke'}`,
        },
    },
    templateHorizontal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 160,
        width: 160,
        minWidth: 160,
        transform: 'rotate(90deg)',
        background: theme.palette.colorNeutral20,
        '&:hover': {
            transform: 'rotate(90deg) scale(1.025)',
            border: `1px solid ${theme.palette.colorNeutral20 || '#ccc'}`,
            boxShadow: `5px 3px ${theme.palette.colorNeutral20 || 'whitesmoke'}`,
        },
    },
    templateButton: {
        background: 'transparent',
        outline: 'none',
        border: 'none',
    },
});

const CardTemplate = ({
    template,
    classes,
    setCardTemplate,
}) => {
    const cardOrientationClass = template?.card_orientation === 'Vertical'
        ? classes.templateVertical
        : classes.templateHorizontal;
    return (
        template
            && (
                <Grid key={template.uid} item xs={6} sm={4} md={2} className={classes.box}>
                    <Grid className={cardOrientationClass}>
                        <button type="submit" onClick={() => setCardTemplate(template)} className={classes.templateButton}>
                            <img
                                src={template.front_view?.card_image?.url}
                                className={classes.image}
                                alt={template.title}
                            />
                        </button>
                    </Grid>
                    <h3 className={classes.templateTitle}>{template.title}</h3>
                </Grid>
            )
    );
};

CardTemplate.propTypes = {
    classes: object.isRequired,
    template: shape({
        front_view: shape({
            card_image: shape({
                url: string,
            }),
        }),
        title: string,
        card_orientation: string,
        uid: string,
    }).isRequired,
    setCardTemplate: func.isRequired,
};

export default withStyles(styles)(CardTemplate);
